import React from 'react';
import { Route, Routes } from 'react-router-dom';

import ValidatorDetail from './ValidatorDetail';
import ValidatorDelegation from './ValidatorDelegation';

export default function ValidatorNode() {
  return (
    <Routes>
      <Route path="/" element={<ValidatorDetail />} />
      <Route path="/delegate" element={<ValidatorDelegation direction="DELEGATE" />} />
      <Route path="/undelegate" element={<ValidatorDelegation direction="UNDELEGATE" />} />
    </Routes>
  );
}
